import axios from 'axios';

// Create axios instance with default config
const axiosClient = axios.create({
  headers: {
    'Content-Type': 'application/json',
    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || ''
  }
});

// Add response interceptor for error handling
axiosClient.interceptors.response.use(
  response => response,
  error => {
    // Handle common errors here
    console.error('API Error:', error);
    return Promise.reject(error);
  }
);

export default axiosClient;